/**
 * Latest Articles Grid Slider
 * Profesjonalny slider z infinite loop i strzałkami nawigacyjnymi
 */

(function() {
  'use strict';

  // Sprawdź czy klasa już istnieje
  if (window.LatestArticlesGridSlider) {
    return;
  }

  class LatestArticlesGridSlider {
    constructor(section) {
      this.section = section;
      // Szukaj track zarówno w .latest-articles-grid jak i .latest-articles-grid__wrapper
      this.track = section.querySelector('[data-slider-track]') || section.querySelector('.latest-articles-grid__track');
      this.prevButton = section.querySelector('.latest-articles-grid__arrow--prev');
      this.nextButton = section.querySelector('.latest-articles-grid__arrow--next');
      
      // Sprawdź czy jesteśmy na mobile
      this.isMobile = window.innerWidth <= 768;
      
      // Jeśli nie jesteśmy na mobile, nie inicjalizuj slidera
      if (!this.isMobile) {
        return;
      }
      
      this.slides = this.track ? Array.from(this.track.querySelectorAll('.latest-articles-grid__slide')) : [];
      
      // Slider działa tylko jeśli mamy więcej niż 1 slajd
      if (!this.track || this.slides.length <= 1) {
        // Ukryj strzałki jeśli jest tylko 1 slajd
        if (this.prevButton && this.nextButton) {
          this.prevButton.style.opacity = '0';
          this.prevButton.style.pointerEvents = 'none';
          this.nextButton.style.opacity = '0';
          this.nextButton.style.pointerEvents = 'none';
        }
        return;
      }
      
      this.currentIndex = 0;
      this.isTransitioning = false;
      this.slideWidth = 0; // będzie obliczone dynamicznie
      this.gap = 0; // gap między slajdami w px (na mobile bez gapu bo pełna szerokość)
      this.visibleSlides = 1; // na mobile zawsze 1
      
      this.init();
      
      // Pokaż strzałki tylko jeśli mamy więcej niż 1 slajd
      if (this.prevButton && this.nextButton) {
        this.prevButton.style.opacity = '1';
        this.prevButton.style.pointerEvents = 'auto';
        this.nextButton.style.opacity = '1';
        this.nextButton.style.pointerEvents = 'auto';
      }
    }

  init() {
    // Klonuj slajdy dla infinite loop
    this.cloneSlides();
    
    // Ustaw początkową pozycję
    this.updateSlideWidth();
    
    // Ustaw pozycję strzałek względem obrazów
    this.updateArrowPosition();
    
    // Poczekaj na następny frame, aby upewnić się, że szerokości są ustawione
    requestAnimationFrame(() => {
      this.setPosition(this.currentIndex, false);
      // Opóźnij updateArrowPosition, aby uniknąć layout thrashing
      setTimeout(() => this.updateArrowPosition(), 100);
    });
    
    // Event listeners
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.prev());
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.next());
    }
    
    // Touch events dla swipe
    this.setupTouchEvents();
    
    // Resize handler z debounce
    let resizeTimeout;
    window.addEventListener('resize', () => {
      if (!this.isMobile) return;
      
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.updateSlideWidth();
        requestAnimationFrame(() => {
          this.setPosition(this.currentIndex, false);
          setTimeout(() => this.updateArrowPosition(), 100);
        });
      }, 150);
    }, { passive: true });
    
    // Obsługa przejścia (transition end) - tylko raz
    this.track.addEventListener('transitionend', () => {
      this.handleTransitionEnd();
    }, { once: false });
  }
  
  updateArrowPosition() {
    if (!this.isMobile || this.slides.length === 0 || !this.prevButton || !this.nextButton) return;
    
    // Użyj requestAnimationFrame, aby uniknąć layout thrashing
    requestAnimationFrame(() => {
      // Znajdź pierwszy slajd i jego obraz
      const firstSlide = this.slides.find(slide => !slide.classList.contains('latest-articles-grid__slide--clone')) || this.slides[0];
      if (!firstSlide) return;
      
      const imageWrapper = firstSlide.querySelector('.article-card-related__image');
      if (!imageWrapper) return;
      
      const imageHeight = imageWrapper.offsetHeight;
      if (imageHeight === 0) return; // Obraz jeszcze nie załadowany
      
      const sectionRect = this.section.getBoundingClientRect();
      const imageRect = imageWrapper.getBoundingClientRect();
      const imageTop = imageRect.top - sectionRect.top;
      const arrowTop = imageTop + (imageHeight / 2) - 24; // 24px to połowa wysokości strzałki (48px)
      
      this.prevButton.style.top = `${arrowTop}px`;
      this.nextButton.style.top = `${arrowTop}px`;
    });
  }

  cloneSlides() {
    if (this.slides.length === 0) return;
    
    // Klonuj pierwsze 3 slajdy na koniec
    for (let i = 0; i < Math.min(3, this.slides.length); i++) {
      const clone = this.slides[i].cloneNode(true);
      clone.classList.add('latest-articles-grid__slide--clone');
      this.track.appendChild(clone);
    }
    
    // Klonuj ostatnie 3 slajdy na początek
    const lastSlides = this.slides.slice(-Math.min(3, this.slides.length));
    for (let i = lastSlides.length - 1; i >= 0; i--) {
      const clone = lastSlides[i].cloneNode(true);
      clone.classList.add('latest-articles-grid__slide--clone');
      this.track.insertBefore(clone, this.track.firstChild);
    }
    
    // Zaktualizuj listę slajdów
    this.slides = Array.from(this.track.querySelectorAll('.latest-articles-grid__slide'));
    
    // Ustaw początkowy index na pierwszy prawdziwy slajd (po klonach)
    this.currentIndex = Math.min(3, this.slides.length - 6);
  }

  updateSlideWidth() {
    if (this.slides.length === 0) return;
    
    // Na mobile używamy pełnej szerokości kontenera
    const container = this.section.querySelector('.latest-articles-grid__slider-container');
    if (container) {
      const containerWidth = container.offsetWidth;
      this.slideWidth = containerWidth;
    }
    
    // Ustaw szerokość slajdów
    this.slides.forEach(slide => {
      slide.style.width = `${this.slideWidth}px`;
      slide.style.flexShrink = '0';
    });
  }

  setPosition(index, smooth = true) {
    if (this.isTransitioning) return;
    
    const offset = -(index * (this.slideWidth + this.gap));
    
    // Użyj transform3d dla lepszej wydajności GPU
    if (smooth) {
      this.track.style.transition = 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      this.isTransitioning = true;
    } else {
      this.track.style.transition = 'none';
    }
    
    this.track.style.transform = `translate3d(${offset}px, 0, 0)`;
  }

  handleTransitionEnd() {
    if (!this.isTransitioning) return;
    
    this.isTransitioning = false;
    
    const originalSlidesCount = this.slides.length - (Math.min(3, this.slides.length) * 2);
    if (originalSlidesCount <= 0) return;
    
    const firstRealIndex = Math.min(3, this.slides.length - 6);
    const lastRealIndex = firstRealIndex + originalSlidesCount - 1;
    
    // Jeśli jesteśmy na klonie na początku, przeskocz na koniec
    if (this.currentIndex < firstRealIndex) {
      const offset = firstRealIndex - this.currentIndex;
      this.currentIndex = lastRealIndex - offset + 1;
      requestAnimationFrame(() => {
        this.setPosition(this.currentIndex, false);
      });
    }
    // Jeśli jesteśmy na klonie na końcu, przeskocz na początek
    else if (this.currentIndex > lastRealIndex) {
      const offset = this.currentIndex - lastRealIndex;
      this.currentIndex = firstRealIndex + offset - 1;
      requestAnimationFrame(() => {
        this.setPosition(this.currentIndex, false);
      });
    }
  }

  prev() {
    if (this.isTransitioning) return;
    this.currentIndex--;
    this.setPosition(this.currentIndex, true);
  }

  next() {
    if (this.isTransitioning) return;
    this.currentIndex++;
    this.setPosition(this.currentIndex, true);
  }

  setupTouchEvents() {
    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    let startTranslate = 0;
    let currentTranslate = 0;
    let animationFrameId = null;

    this.track.addEventListener('touchstart', (e) => {
      if (this.isTransitioning) return;
      
      startX = e.touches[0].clientX;
      isDragging = true;
      
      // Pobierz aktualną pozycję z transform
      const transform = window.getComputedStyle(this.track).transform;
      if (transform && transform !== 'none') {
        const matrix = transform.match(/matrix\(([^)]+)\)/);
        if (matrix) {
          startTranslate = parseFloat(matrix[1].split(',')[4]) || 0;
        }
      } else {
        startTranslate = -(this.currentIndex * (this.slideWidth + this.gap));
      }
      
      this.track.style.transition = 'none';
      
      // Anuluj poprzednią animację jeśli istnieje
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    }, { passive: true });

    this.track.addEventListener('touchmove', (e) => {
      if (!isDragging || this.isTransitioning) return;
      
      currentX = e.touches[0].clientX;
      currentTranslate = startTranslate + (currentX - startX);
      
      // Użyj requestAnimationFrame dla płynności
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
      
      animationFrameId = requestAnimationFrame(() => {
        this.track.style.transform = `translate3d(${currentTranslate}px, 0, 0)`;
      });
    }, { passive: true });

    this.track.addEventListener('touchend', () => {
      if (!isDragging) return;
      
      isDragging = false;
      
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
        animationFrameId = null;
      }
      
      const diff = startX - currentX;
      const threshold = 50; // minimalna odległość dla swipe
      
      if (Math.abs(diff) > threshold && !this.isTransitioning) {
        if (diff > 0) {
          this.next();
        } else {
          this.prev();
        }
      } else {
        // Wróć do aktualnej pozycji
        this.setPosition(this.currentIndex, true);
      }
    }, { passive: true });
    
    // Obsługa touchcancel
    this.track.addEventListener('touchcancel', () => {
      isDragging = false;
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
        animationFrameId = null;
      }
      this.setPosition(this.currentIndex, true);
    }, { passive: true });
  }
}

  // Eksportuj klasę do window
  window.LatestArticlesGridSlider = LatestArticlesGridSlider;

  // Inicjalizacja wszystkich sekcji
  function initSliders() {
    // Szukaj zarówno .latest-articles-grid jak i .latest-articles-grid__wrapper (dla search-results)
    const sections = document.querySelectorAll('.latest-articles-grid, .latest-articles-grid__wrapper');
    sections.forEach(section => {
      // Sprawdź czy slider już został zainicjalizowany
      if (!section.dataset.sliderInitialized) {
        const slider = new LatestArticlesGridSlider(section);
        // Tylko oznacz jako zainicjalizowany jeśli slider został utworzony (na mobile)
        if (slider && slider.track) {
          section.dataset.sliderInitialized = 'true';
        }
      }
    });
  }

  // Inicjalizacja przy załadowaniu DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }

  // Obsługa dla Shopify Theme Editor
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.latest-articles-grid');
      if (section && !section.dataset.sliderInitialized) {
        new LatestArticlesGridSlider(section);
        section.dataset.sliderInitialized = 'true';
      }
    });
    
    document.addEventListener('shopify:section:reorder', () => {
      initSliders();
    });
  }
})();

